/** A step of 1, 2 or 5 times a power of ten that splits `span` in about `parts`. */
export function niceStep(span: number, parts = 2): number {
  if (span <= 0) return 1;
  const raw = span / parts;
  const magnitude = 10 ** Math.floor(Math.log10(raw));
  const norm = raw / magnitude;
  return (norm >= 5 ? 5 : norm >= 2 ? 2 : 1) * magnitude;
}

/**
 * Round tick values from the step at or below `min` up to `max`. The lowest one
 * reaches below a negative minimum, so a value under zero stays on the scale.
 */
export function niceTicks(min: number, max: number, parts = 2): number[] {
  const step = niceStep(max - Math.min(0, min), parts);
  const first = Math.floor(Math.min(0, min) / step) * step;
  const ticks: number[] = [];
  for (let v = first; v <= max + 1e-9; v += step) ticks.push(v);
  return ticks;
}

/**
 * Round tick values from the step at or below `min` up to `max`, without reaching
 * down to zero: for a line, where an axis from zero would flatten the changes.
 */
export function bandTicks(min: number, max: number, parts = 2): number[] {
  const step = niceStep(max - min, parts);
  const first = Math.floor(min / step) * step;
  const ticks: number[] = [];
  for (let v = first; v <= max + 1e-9; v += step) ticks.push(v);
  return ticks;
}
